'use strict';

import classNames from 'classnames';
import debounce from 'lodash.debounce';
import indexBy from 'lodash.indexby';
import moment from 'moment';
import platform from 'platform';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import React, { Component, createRef } from 'react';
import Helmet from 'react-helmet';
import Modal from 'react-modal';

import FoodUnitsSelector from '../components/DailyLog/FoodUnitsSelectorModal.react';
import SwapMenu from '../components/Dashboard/SwapMenu.react';
import FoodEditorModal from '../components/Foods/Modals/FoodEditorModal';
import Orders from '../components/MealDetails/Orders.react';
import SpringHero from '../components/MealDetails/SpringHero.react';
import FoodIngredients from '../components/Modules/FoodIngredients.react';
import RecipeIngredients from '../components/Modules/RecipeIngredients.react';
import RecipeInstructions from '../components/Modules/RecipeInstructions.react';
import ConfirmOverwriteModal from '../components/Planner/Modals/ConfirmOverwriteModal.react';
import LeftoverDatesModal from '../components/Planner/Modals/LeftoverDatesModal.react';
import LocationInfo from '../components/Products/LocationInfo.react';
import NutritionInfo from '../components/Products/NutritionInfo.react';
import AddToCollectionButton from '../components/Recipes/AddToCollectionButton.react';
import RecipeEditor from '../components/Recipes/Editor.react';
import EditImage from '../components/Recipes/Editor/EditImage.react';
import HowMuchToEat from '../components/Recipes/HowMuchToEat.react';
import Merchant from '../components/Recipes/Merchant.react';
import RecipeToPdfButton from '../components/Recipes/RecipeToPdfButton.react';
import SchedulingModal from '../components/Recipes/SchedulingModal.react';
import Alert from '../components/Widgets/Alert/Alert.react';
import Popup from '../components/Widgets/Popup.react';
import MyTabs from '../components/Widgets/Tabs.react';
import Dropdown from '../pro/components/Widgets/Dropdown.react';

import LoginForm from '../components/Widgets/LoginForm.react';
import Footer from '../components/Widgets/footer/Footer.react';

import GroceryActions from '../actions/GroceryActions';
import MealActions from '../actions/MealActions';
import MealStore from '../stores/MealStore';
import PlanStore from '../stores/PlanStore';
import UserStore from '../stores/UserStore';

import Analytics from '../utils/Analytics';

import { toHuman } from '../utils/Duration';
import { getConfig } from '../utils/Env';
import { isMealInGroceries } from '../utils/Grocery';
import {
    enrichMealsForSorting,
    getLoggedServingsOfRecipe,
    getMealTypesForDate,
    getParticipantsForMeal,
    getPrimaryMeal,
    getServingsNeededWithLoggedServings,
    isScalable,
    shouldCreateLeftovers,
    getRescheduleOverlaps,
    getParticipantsForSpecificMeal,
    mealSortCompare,
    updateMealLeftovers,
} from '../utils/Meals';
import {
    calculateTotalServingsForParticipants,
    calculateRequiredScaling,
    calculateTotalYield,
    getBaseServings,
} from '../utils/servingsCalculations';
import { compareNutrientsToEnvelope, computeDefaultMealRx, getNutrientsForMeals } from '../utils/Nutrition';
import { ScreenService } from '../utils/ScreenService';
import { isSunbasketFood } from '../utils/Sunbasket';

import '../components/FeedModals.scss';
import GroceryButton from '../components/Groceries/GroceryButton/GroceryButton.react';
import MealTitle from '../components/Meals/MealTitle.react';
import MultiSharePopup from '../components/Widgets/MultiSharePopUp.react';
import './MealDetails.scss';


const sections = ['first', 'second', 'third', 'fourth', 'fifth'];

export default class MealDetails extends Component {
    static propTypes = {
        profile: PropTypes.object,

        hidePrintBtn: PropTypes.bool,
        hideEditBtns: PropTypes.bool,
    };

    static defaultProps = {
        hidePrintBtn: false,
        hideEditBtns: false,
    };

    static contextTypes = {
        confirm: PropTypes.func,
        router: PropTypes.object,
        location: PropTypes.object,
        isMobile: PropTypes.bool,
        isCordova: PropTypes.bool,
        isPro: PropTypes.bool,
        breakpoint47em: PropTypes.bool,

        currentMealType: PropTypes.string,

        user: PropTypes.object,
        plans: PropTypes.array,
        meals: PropTypes.array,
        recipes: PropTypes.object,
        details: PropTypes.object,
        foods: PropTypes.object,
        merchants: PropTypes.object,
        locations: PropTypes.object,
        brands: PropTypes.object,

        groceries: PropTypes.array,

        editMealBatches: PropTypes.func,
        onModifyMeal: PropTypes.func,
        onModifyMeals: PropTypes.func,
        onRemoveMeals: PropTypes.func,
        startAddMeal: PropTypes.func,
        startReplaceMeal: PropTypes.func,
        showUpgradeForm: PropTypes.func,
    };

    constructor(props, context) {
        super(props, context);

        const profile = this.getProfileFromProps(props, context);
        const meals = this.getMealsFromProps(props, context);

        this.state = {
            profile,
            ...this.getSyncState(props, context, meals, profile),

            dishIndex: context?.location?.query?.dishIndex || 0,
            nutrientsIndex: context?.location?.query?.nutrientsIndex || 0,
            editMealModal: null,

            // Leftover modal state
            isLeftoverDatesModalOpen: false,
            leftoverModalParams: null,
            pendingSchedule: null,
            confirmLeftoverDates: null,
        };

        this.scrollable = createRef();
        this.syncScaling = debounce(this.syncScaling, 500);
        this.nutrientTabsRef = React.createRef();
    }

    componentDidMount = () => {
        ScreenService.keepAwake();
        UserStore.addChangeListener(this.onUserStoreChange);
        MealStore.addChangeListener(this.onMealStoreChange);

        const { mealType, date, meals } = this.state;

        Analytics.viewMeal({
            'Meal UUIDs': meals.map((m) => m.uuid),
            'Meal Type': mealType,
            Date: moment(date).format('YYYY-MM-DD'),
        });

        this.syncScaling();
    };

    componentWillUnmount = () => {
        ScreenService.allowSleep();
        UserStore.removeChangeListener(this.onUserStoreChange);
        MealStore.removeChangeListener(this.onMealStoreChange);
    };

    UNSAFE_componentWillReceiveProps = (nextProps, nextContext) => {
        const profile = this.getProfileFromProps(nextProps, nextContext);
        const meals = this.getMealsFromProps(nextProps, nextContext);

        this.setState(this.getSyncState(nextProps, nextContext, meals, profile), this.syncScaling);
    };

    onUserStoreChange = () => {
        const profile = this.getProfileFromProps(this.props, this.context);
        const meals = this.getMealsFromProps(this.props, this.context);

        this.setState(this.getSyncState(this.props, this.context, meals, profile), this.syncScaling);
    };

    onMealStoreChange = () => {
        const profile = this.getProfileFromProps(this.props, this.context);
        const meals = this.getMealsFromProps(this.props, this.context);
        this.setState(this.getSyncState(this.props, this.context, meals, profile), this.syncScaling);
    };

    getMealsFromProps = (props, context) => {
        return props.meals || context.meals || MealStore.getMeals();
    };

    getProfileFromProps = (props, context) => {
        return props.profile || context.profile || UserStore.getUser();
    };

    getSyncState = (props, context, allMeals, profile) => {
        const { params } = props;
        const { mealType = 'Dinner' } = params;
        const { recipes, foods, details } = context;

        if (!profile) {
            return { meals: [], date, mealType, primary: null, participants: [], profile, mismatches: [] };
        }

        const date = params.date ? moment(params.date) : moment();
        let meals = allMeals
            .filter((m) => !m.deleted && date.isSame(m.date, 'day') && m.meal === mealType)
            .filter((m) => !['note'].includes(m.meal_type));

        // Enrich meals with sorting flags before sorting
        meals = enrichMealsForSorting(meals, recipes, details, foods);
        meals = meals.sort(mealSortCompare);

        const primary = getPrimaryMeal(meals, recipes, foods);
        const allContent = { ...recipes, ...foods };
        const nutrients = getNutrientsForMeals(meals, allContent, profile.portion);

        if (!meals.length) {
            return { meals: [], date, mealType, primary: null, participants: [], profile, mismatches: [] };
        }

        // Find the daily rx from preferences
        const allDayRx = profile.preferences?.daily_totals || null;

        // Find meal-specific prescription from preferences
        const mealTypeInfo = (profile.preferences?.meal_types || []).find(mt => mt.name === primary.primary.meal);
        let mealRx = mealTypeInfo?.envelope ? { envelope: mealTypeInfo.envelope, meal_type: primary.primary.meal } : null;
        mealRx = mealRx || (allDayRx ? computeDefaultMealRx(allDayRx, primary.primary.meal, true) : {});
        let mismatches =
            meals.length && mealRx.envelope && nutrients
                ? compareNutrientsToEnvelope(nutrients, mealRx.envelope, ['FRU'])
                : [];
        let isMismatched = meals.length > 0 && mismatches.length > 0;
        let isOverLimits = mismatches.filter((miss) => miss.value > miss.max).length > 0;

        return {
            meals,
            date,
            mealType,
            primary,
            participants: getParticipantsForSpecificMeal(primary.primary, profile),
            profile,
            mismatches,
            isMismatched,
            isOverLimits,
        };
    };

    // If the participants + leftovers become desynced from the scaling, this fixes it automatically.
    syncScaling = () => {
        const { profile, meals } = this.state;
        const { recipes, onModifyMeals, location } = this.context;

        const dishIndex = location?.query?.dishIndex || 0;
        const nutrientsIndex = location?.query?.nutrientsIndex || 0;

        // Use all meals (not just current day) to find leftovers across all days
        const allMeals = this.getMealsFromProps(this.props, this.context);

        const dirtyMeals = [];

        meals.forEach((meal) => {
            if (!meal.recipe_uuid) {
                return;
            }

            const recipe = recipes[meal.recipe_uuid];
            if (!(recipe && recipe.servings > 0)) {
                return;
            }

            const participants = getParticipantsForSpecificMeal(meal, profile);
            const loggedServings = getLoggedServingsOfRecipe(meal, recipe);
            const neededPerMeal = getServingsNeededWithLoggedServings(participants, loggedServings);

            // Calculate total needed by summing each meal's actual needs based on its participants
            // Don't assume all leftovers have same participants as main meal
            // Search allMeals (not just current day) to find leftovers across all days
            const leftoverMeals = allMeals.filter(
                (m) => m.meal_type == 'leftover' && !m.deleted && m.parent_uuid == meal.uuid
            );

            let totalNeeded = neededPerMeal; // Start with main meal
            const leftoverNeeds = [];
            leftoverMeals.forEach(leftover => {
                const leftoverParticipants = getParticipantsForSpecificMeal(leftover, profile);
                const leftoverLogged = getLoggedServingsOfRecipe(leftover, recipe);
                const leftoverNeeded = getServingsNeededWithLoggedServings(leftoverParticipants, leftoverLogged);
                leftoverNeeds.push(leftoverNeeded);
                totalNeeded += leftoverNeeded;
            });

            const minScaling = calculateRequiredScaling(totalNeeded + (meal.extra_servings || 0), getBaseServings(recipe));

            if (meal.scaling < minScaling) {
                meal.scaling = minScaling;
                dirtyMeals.push(meal);
            }
        });

        if (dirtyMeals.length > 0) {
            onModifyMeals(dirtyMeals);
        }

        // On resyncing, reset horizontal scroll
        this.scrollToDishIndex(dishIndex, nutrientsIndex);
    };

    getOrdersForMeal(meal) {
        const orders = [];
        if (!meal?.orders?.length) {
            return orders;
        }

        const allOrders = indexBy(MealStore.getOrders(), 'uuid');

        meal.orders.forEach((orderUuid) => {
            if (allOrders[orderUuid]) {
                orders.push(allOrders[orderUuid]);
            }
        });

        return orders;
    }

    renderMealControlButtons = (meal, content, canEditSingleMeal = true) => {
        const { meals, profile } = this.state;
        const { inhibit_swap = false, rd_override = false } = profile || {};
        const { hideEditBtns } = this.props;
        const buttons = [];

        if (hideEditBtns || (inhibit_swap && !rd_override)) {
            return;
        }

        if (profile?.role === 'admin' && meal.food_uuid) {
            buttons.push(
                <a
                    key="admin"
                    target="_blank"
                    rel="noreferrer"
                    href={'https://' + getConfig('www_host') + `/admin/foods/${meal.food_uuid}`}
                >
                    <button className="edit-meal-btn">
                        <i className="feather feather-box" />
                        <em>admin</em>
                    </button>
                </a>
            );
        }

        if (profile?.role === 'admin' && meal.recipe_uuid) {
            buttons.push(
                <a
                    key="admin"
                    target="_blank"
                    rel="noreferrer"
                    href={'https://' + getConfig('www_host') + `/publisher/recipe/${meal.recipe_uuid}`}
                >
                    <button className="edit-meal-btn">
                        <i className="feather feather-box" />
                        <em>admin</em>
                    </button>
                </a>
            );
        }

        if (content.type == 'recipe') {
            buttons.push(<AddToCollectionButton key="collection" recipe={content} />);
        }

        if (canEditSingleMeal && !profile?.features?.inhibit_edit_recipe) {
            buttons.push(
                <button key="edit" className="edit-meal-btn" onClick={(ev) => this.editSingleMeal(meal, ev)}>
                    <i className="feather feather-edit" />
                    <em>Edit</em>
                </button>
            );
        }

        if (meals.length > 1) {
            buttons.push(
                <button key="delete" className="delete-dish-btn" onClick={(ev) => this.deleteSingleMeal(meal, ev)}>
                    <i className="feather feather-trash" />
                    <em>Remove</em>
                </button>
            );
        }

        return <div className="meal-control-btns">{buttons}</div>;
    };

    renderRecipe = (meal, recipe) => {
        const { meals, profile, dishIndex } = this.state;
        const { foods, recipes, details, merchants, editMealBatches } = this.context;

        const merchant = recipe.merchant && merchants[recipe.merchant.uuid];
        let participants = getParticipantsForSpecificMeal(meal, profile);
        const neededPerMeal = participants.reduce((total, member) => total + member.portion, 0);
        let parent = null;
        let hasChild = false;
        let leftoversList = [];

        if (meal.meal_type == 'leftover') {
            parent = this.context.meals.find((item) => item.uuid === meal.parent_uuid);
            leftoversList  = this.context.meals.filter((item) => item.parent_uuid === meal.parent_uuid);
        }

        if (meal.meal_type !== 'leftover') {
            hasChild = !!this.context.meals.find((item) => item.parent_uuid === meal.uuid);
            leftoversList  = this.context.meals.filter((item) => item.parent_uuid === meal.uuid);
        }

        // How much waste servings will this option produce?
        const totalDays = leftoversList.length + 1;

        let surplus = !hasChild && !parent;

        // Phase 1: Calculate leftover servings per dish
        const leftoverServingsPerDish = meals.map((meal, dishIndex) => {
            const dish = getPrimaryMeal([meal], recipes, foods);
            if (!(dish && (dish.recipe || dish?.food?.servings))) {
                return 0;
            }

            const dishContent = dish.recipe || dish.food;

            if (parent) {
                // For leftover meals: sum servings of FUTURE sibling leftovers only
                const futureSiblings = this.context.meals.filter(m =>
                    m.parent_uuid === meal.parent_uuid &&
                    m.meal_type === 'leftover' &&
                    m.date > meal.date &&
                    !m.deleted
                );

                let total = 0;
                futureSiblings.forEach(siblingMeal => {
                    const participants = getParticipantsForSpecificMeal(siblingMeal, profile);
                    total += calculateTotalServingsForParticipants(participants, siblingMeal, dishContent);
                });
                return total;
            }

            // For parent meals: sum servings across all child leftover meals
            const childLeftovers = this.context.meals.filter(m =>
                m.parent_uuid === meal.uuid &&
                m.meal_type === 'leftover' &&
                !m.deleted
            );

            let totalLeftoverServings = 0;
            childLeftovers.forEach(leftoverMeal => {
                const leftoverParticipants = getParticipantsForSpecificMeal(leftoverMeal, profile);
                totalLeftoverServings += calculateTotalServingsForParticipants(
                    leftoverParticipants,
                    leftoverMeal,
                    dishContent
                );
            });

            return totalLeftoverServings;
        });

        const eatThisMuchTabs = meals
            .map((meal, i) => {
                const dish = getPrimaryMeal([meal], recipes, foods);

                if (!(dish && (dish.recipe || dish?.food?.servings))) {
                    return null;
                }

                // Derive parent for THIS dish specifically (not the outer slot-level parent)
                const dishParent = meal.meal_type === 'leftover'
                    ? this.context.meals.find(item => item.uuid === meal.parent_uuid)
                    : null;

                let factor = 1;

                // Phase 2: Fix factor calculation for leftover meals
                if (dishParent) {
                    const daysPassed = moment(meal.date).diff(moment(dishParent.date), 'day');
                    if (daysPassed >= 1) {
                        const dishContent = dish.recipe || dish.food;
                        const baseServings = getBaseServings(dishContent);
                        const totalYield = meal.scaling * baseServings;

                        // Calculate actual servings consumed on previous days
                        let servingsConsumedOnPreviousDays = 0;

                        // Get all leftover meals between parent and current meal, sorted by date
                        const allLeftovers = this.context.meals
                            .filter(m =>
                                m.parent_uuid === dishParent.uuid &&
                                m.meal_type === 'leftover' &&
                                moment(m.date).isBefore(moment(meal.date)) &&
                                !m.deleted
                            )
                            .sort((a, b) => moment(a.date).diff(moment(b.date)));

                        // Add servings consumed on original parent meal
                        const parentParticipants = getParticipantsForSpecificMeal(dishParent, profile);
                        servingsConsumedOnPreviousDays += calculateTotalServingsForParticipants(
                            parentParticipants,
                            dishParent,
                            dishContent
                        );

                        // Add servings consumed on each previous leftover meal
                        allLeftovers.forEach(leftoverMeal => {
                            const leftoverParticipants = getParticipantsForSpecificMeal(leftoverMeal, profile);
                            servingsConsumedOnPreviousDays += calculateTotalServingsForParticipants(
                                leftoverParticipants,
                                leftoverMeal,
                                dishContent
                            );
                        });

                        const remainingServings = totalYield - servingsConsumedOnPreviousDays;
                        factor = remainingServings > 0 ? remainingServings / totalYield : 0;
                    }
                    if (totalDays - daysPassed == 1) {
                        surplus = true;
                    }
                }

                const parentMealDate = dishParent && dishParent.date
                    ? moment(dishParent.date).format('MMM D')
                    : null;

                return (
                    <section key={i} data-title={'Dish ' + (i + 1)}>
                        <HowMuchToEat
                            dishNumber={meals.length > 1 ? i + 1 : 0}
                            meal={meal}
                            uuid={meal.uuid}
                            profile={profile}
                            recipe={dish.recipe || dish.food}
                            participants={participants}
                            factor={factor}
                            scaling={meal.scaling}
                            surplus={surplus}
                            leftoverServings={leftoverServingsPerDish[i] || 0}
                            onClick={editMealBatches ? () => editMealBatches(meal) : undefined}
                            isLeftover={!!dishParent}
                            parentMealDate={parentMealDate}
                        />
                    </section>
                );
            })
            .filter((v) => v);

        return (
            <>
                <div className={classNames('details-section', sections[this.section++])}>
                    <header>
                        <div className="section-title">
                            {meal.meal_type === 'leftover' && parent ? (
                                <p className="leftover-badge">
                                    Leftover from {moment(parent.date).format('ddd, MMM Do')}
                                </p>
                            ) : null}
                            {merchant ? (
                                <div className="t2 with-merchant">
                                    <Dropdown
                                        className="merchant-dropdown"
                                        button={
                                            <>
                                                {meals.length > 1 ? <span>DISH {parseInt(dishIndex) + 1}:&nbsp;</span> : null}
                                                <span>Recipe by</span> <em>{merchant.name}</em>{' '}
                                                <i className="feather feather-info" />
                                            </>
                                        }
                                    >
                                        <Merchant merchant={merchant} />
                                    </Dropdown>
                                </div>
                            ) : meals.length > 1 ? (
                                <p className="t2">DISH {parseInt(dishIndex) + 1}</p>
                            ) : null}
                        </div>

                        {this.renderMealControlButtons(meal, recipe, true)}
                    </header>

                    <div className="section-body">
                        <MealTitle
                            item={recipe}
                            meal={meal}
                            nutrientsIndex={parseInt(dishIndex) + 1}
                        />

                        <RecipeIngredients
                            recipe={recipe}
                            details={details[recipe.details]}
                            subdetails={details}
                            scaling={meal.scaling}
                            profile={profile}
                        />

                        <RecipeInstructions
                            recipe={recipe}
                            isMeal={true}
                            details={details[recipe.details]}
                            subdetails={details}
                            user={profile}
                        />
                    </div>
                </div>

                {recipe.servings ? (
                    <div className={classNames('details-section', sections[this.section++])}>
                        <header>
                            <div className="section-title">
                                <p className="t2">How Much to Eat</p>
                            </div>
                        </header>

                        <div className="section-body">
                            {eatThisMuchTabs.map(eatThisMuchTab => {
                                return eatThisMuchTab;
                            })}
                        </div>
                    </div>
                ) : null}
            </>
        );
    };

    renderPicsOrItDidntHappen = (food) => {
        if (!food.image && !food.nfp_image && !food.ingredients_image) {
            return;
        }

        return (
            <div className="image-editor">
                <div className="image-inputs">
                    {food.image ? (
                        <div className="image-input">
                            <EditImage image={food.image} showFooter={false} />
                        </div>
                    ) : null}

                    {food.nfp_image ? (
                        <div className="image-input">
                            <EditImage image={food.nfp_image} showFooter={false} />
                        </div>
                    ) : null}

                    {food.ingredients_image ? (
                        <div className="image-input">
                            <EditImage image={food.ingredients_image} showFooter={false} />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

    renderFood = (meal, food) => {
        const { locations, brands, foods, recipes, editMealBatches } = this.context;
        const { meals, profile, dishIndex } = this.state;

        const location = (locations && locations[meal.location_uuid]) || null;
        const brand = (food.brand_uuid && brands && brands[food.brand_uuid]) || null;
        const currentLocation = UserStore.getLocation();

        const canEditFood = true; // Allow editing any food (will create copy when needed)

        const dishTitles = {
            'Restaurant Dish': (
                <>
                    <span>Order from</span> <em>{food.brand_name}</em>
                </>
            ),
            'Ready Made Meal': food.brand_name ? (
                <>
                    <span>Ready Made Meal by</span> <em>{food.brand_name}</em>
                </>
            ) : (
                'Ready Made Meal'
            ),
            'Brand Name Food': <span>Store Bought Item</span>,
            Food: <></>,
            UGC: <span>Custom Food</span>,
            'Meal Kit': food.brand_name ? (
                <>
                    <span>Meal kit by</span> <em>{food.brand_name}</em>
                </>
            ) : (
                'Meal kit'
            ),
        };

        let participants = getParticipantsForSpecificMeal(meal, profile);
        const neededPerMeal = participants.reduce((total, member) => total + member.portion, 0);
        let parent = null;
        let hasChild = false;

        if (meal.meal_type == 'leftover') {
            parent = this.context.meals.find((item) => item.uuid === meal.parent_uuid);
        }

        if (meal.meal_type !== 'leftover') {
            hasChild = !!this.context.meals.find((item) => item.parent_uuid === meal.uuid);
        }

        // How much waste servings will this option produce?
        const totalServings = food.servings * meal.scaling;
        const totalDays = Math.floor(totalServings / neededPerMeal) || 1;

        let surplus = !hasChild && !parent;

        let dishTitle = dishTitles[food.product_type] || food.product_type;
        const orders = this.getOrdersForMeal(meal);

        let foodPrice = null;

        if (food.mapped_from && food.servings) {
            const mf = food.mapped_from.find((mf) => mf.price);

            if (mf) {
                foodPrice = mf.price / food.servings;
            }
        }

        // Phase 1: Calculate leftover servings for non-leftover meals
        const leftoverServingsPerDishFood = meals.map((meal, dishIndex) => {
            if (parent) {
                // Don't calculate for leftover meals
                return 0;
            }

            const dish = getPrimaryMeal([meal], recipes, foods);
            if (!(dish && (dish.recipe || dish?.food?.servings))) {
                return 0;
            }

            let totalLeftoverServings = 0;

            // Find all child leftover meals
            const childLeftovers = this.context.meals.filter(m =>
                m.parent_uuid === meal.uuid &&
                m.meal_type === 'leftover' &&
                !m.deleted
            );

            // For each leftover meal, calculate servings for this specific dish
            childLeftovers.forEach(leftoverMeal => {
                const leftoverParticipants = getParticipantsForSpecificMeal(leftoverMeal, profile);
                const dishContent = dish.recipe || dish.food;
                totalLeftoverServings += calculateTotalServingsForParticipants(
                    leftoverParticipants,
                    leftoverMeal,
                    dishContent
                );
            });

            return totalLeftoverServings;
        });

        const eatThisMuchTabs = meals
            .map((meal, i) => {
                const dish = getPrimaryMeal([meal], recipes, foods);

                if (!(dish && (dish.recipe || dish?.food?.servings))) {
                    return null;
                }

                let factor = 1;

                // Phase 2: Fix factor calculation for leftover meals
                if (parent) {
                    const daysPassed = moment(meal.date).diff(moment(parent.date), 'day');
                    if (daysPassed >= 1) {
                        const dishContent = dish.food || dish.recipe;
                        const baseServings = getBaseServings(dishContent);
                        const totalYield = meal.scaling * baseServings;

                        // Calculate actual servings consumed on previous days
                        let servingsConsumedOnPreviousDays = 0;

                        // Get all leftover meals between parent and current meal, sorted by date
                        const allLeftovers = this.context.meals
                            .filter(m =>
                                m.parent_uuid === parent.uuid &&
                                m.meal_type === 'leftover' &&
                                moment(m.date).isBefore(moment(meal.date)) &&
                                !m.deleted
                            )
                            .sort((a, b) => moment(a.date).diff(moment(b.date)));

                        // Add servings consumed on original parent meal
                        const parentParticipants = getParticipantsForSpecificMeal(parent, profile);
                        servingsConsumedOnPreviousDays += calculateTotalServingsForParticipants(
                            parentParticipants,
                            parent,
                            dishContent
                        );

                        // Add servings consumed on each previous leftover meal
                        allLeftovers.forEach(leftoverMeal => {
                            const leftoverParticipants = getParticipantsForSpecificMeal(leftoverMeal, profile);
                            servingsConsumedOnPreviousDays += calculateTotalServingsForParticipants(
                                leftoverParticipants,
                                leftoverMeal,
                                dishContent
                            );
                        });

                        const remainingServings = totalYield - servingsConsumedOnPreviousDays;
                        factor = remainingServings > 0 ? remainingServings / totalYield : 0;
                    }
                    if (totalDays - daysPassed == 1) {
                        surplus = true;
                    }
                }

                const parentMealDate = parent && parent.date
                    ? moment(parent.date).format('MMM D')
                    : null;

                return (
                    <section key={i} data-title={'Dish ' + (i + 1)}>
                        <HowMuchToEat
                            dishNumber={meals.length > 1 ? i + 1 : 0}
                            meal={meal}
                            uuid={meal.uuid}
                            profile={profile}
                            recipe={dish.food || dish.recipe}
                            participants={participants}
                            factor={factor}
                            scaling={meal.scaling}
                            surplus={surplus}
                            leftoverServings={leftoverServingsPerDishFood[i] || 0}
                            onClick={editMealBatches ? () => editMealBatches(meal) : undefined}
                            isLeftover={!!parent}
                            parentMealDate={parentMealDate}
                        />
                    </section>
                );
            })
            .filter((v) => v);

        return (
            <>
                <section className={classNames('details-section', sections[this.section++])}>
                    {orders?.length ? (
                        <Orders orders={orders}>
                            <div>
                                <p className="t5">
                                    To change or edit your Sunbasket order, go to{' '}
                                    <a target="_blank" rel="noreferrer" href="https://sunbasket.com/">
                                        sunbasket.com
                                    </a>{' '}
                                    or contact <a href="https://sunbasket.com/help/">Sunbasket support</a>
                                </p>
                            </div>
                        </Orders>
                    ) : null}

                    <header>
                        <div className="section-title">
                            {meal.meal_type === 'leftover' && parent ? (
                                <p className="leftover-badge">
                                    Leftover from {moment(parent.date).format('ddd, MMM Do')}
                                </p>
                            ) : null}
                            <p className="t2">
                                {meals.length > 1 ? <span>DISH {parseInt(dishIndex) + 1}: </span> : null}
                                {dishTitle}
                            </p>
                        </div>

                        {this.renderMealControlButtons(meal, food, canEditFood)}
                    </header>

                    <div className="section-body">
                        <MealTitle
                            item={food}
                            meal={meal}
                            nutrientsIndex={parseInt(dishIndex) + 1}
                        />

                        {this.renderPicsOrItDidntHappen(food)}

                        {food.description ? <p className="t3 description">{food.description}</p> : null}

                        {food.ingredients ? (
                            <>
                                <p className="p3">This meal includes the following ingredients:</p>
                                <FoodIngredients food={food} profile={profile} />
                            </>
                        ) : null}

                        {food.modifications ? (
                            <p className="t3 modifications">
                                <em>Recommended modifications:</em> {food.modifications}
                            </p>
                        ) : null}

                        {food.nutrition_disclaimer ? (
                            <Alert type="warning">
                                <strong>Nutrition Disclaimer:</strong> {food.nutrition_disclaimer}
                            </Alert>
                        ) : null}

                        {food.gtin_upc?.length ? (
                            <p className="t3">
                                <em>Barcode:</em> {food.gtin_upc.join(', ')}
                            </p>
                        ) : null}
                    </div>
                </section>

                {location ? (
                    <div className={classNames('details-section', sections[this.section++])}>
                        <header>
                            <div className="section-title">
                                <p className="t2">Restaurant Information</p>
                            </div>
                        </header>

                        <div className="section-body">
                            <LocationInfo brand={brand} location={location} currentLocation={currentLocation} />
                        </div>
                    </div>
                ) : null}

                {food.preparation ? (
                    <div className={classNames('details-section', sections[this.section++])}>
                        <header>
                            <div className="section-title">
                                <p className="t2">Dish {meals.length === 1 ? null : parseInt(dishIndex) + 1} Instructions</p>
                            </div>
                        </header>

                        <div className="section-body">
                            <RecipeInstructions recipe={food} details={food} user={profile} />
                        </div>
                    </div>
                ) : null}

                {isSunbasketFood(food) ? (
                    <div className={classNames('details-section', sections[this.section++])}>
                        <header>
                            <div className="section-title">
                                <p className="t2">How Much to Eat</p>
                            </div>
                        </header>

                        <div className="section-body">
                            {eatThisMuchTabs.map(eatThisMuchTab => {
                                return eatThisMuchTab;
                            })}
                        </div>
                    </div>
                ) : null}
            </>
        );
    };

    renderNutritionTabs = () => {
        const { dishIndex, nutrientsIndex, profile, meals } = this.state;
        const { recipes, foods, isPro } = this.context;

        const { hide_nutrition = false, rd_override = false } = profile || {};

        if (!(meals && meals.length)) {
            return;
        }

        if (hide_nutrition && rd_override !== true) {
            return;
        }

        const allContent = { ...recipes, ...foods };
        const combinedNutrients = getNutrientsForMeals(meals, allContent, profile.portion, null);

        const nutrientTabs = [];

        nutrientTabs.push(
            <section key="combined" data-title="Combined">
                <h6 className="nutrition-title">Combined Nutrition for All Dishes</h6>
                <NutritionInfo profile={{ ...profile, portion: 1 }} nutrients={combinedNutrients} />
            </section>
        );

        meals.forEach((meal, i) => {
            const dish = getPrimaryMeal([meal], recipes, foods);

            if (!dish) {
                return null;
            }

            let dishNutrients = getNutrientsForMeals([meal], allContent, profile.portion, null);

            const { food } = dish;
            const showAllAvailable = food && profile.uuid === food.owner && food.status !== 'live';

            nutrientTabs.push(
                <section key={i} data-title={'Dish ' + (i + 1)}>
                    {meal.logged_amount ? (
                        <>
                            <h6 className="nutrition-title">
                                {`Nutrition for ${'Dish ' + (i + 1)}: ${dish?.food?.name || dish?.recipe?.title}`}
                            </h6>
                            <div className="nutrition-portion">
                                <p className="t2">
                                    Showing nutrition for {profile.name || `${profile.first_name} ${profile.last_name}`}
                                    :{' '}
                                </p>
                                {meal?.logged_amount && !isPro ? (
                                    <FoodUnitsSelector
                                        food={dish.food || dish.recipe}
                                        meal={meal}
                                        replaceChevronText="edit"
                                        nutrientsIndex={i + 1}
                                    />
                                ) : null}
                            </div>
                        </>
                    ) : null}
                    <NutritionInfo
                        profile={{ ...profile, portion: 1 }}
                        nutrients={dishNutrients}
                        showAllAvailable={showAllAvailable}
                    />
                </section>
            );
        });

        const { content } = getPrimaryMeal([meals[dishIndex]], recipes, foods);

        const defaultTab = nutrientsIndex == 0 ? 'Combined' : 'Dish ' + nutrientsIndex;

        return (
            <div className={classNames('details-section', sections[this.section++])}>
                <header>
                    <div className="section-title">
                        <p className="t2">Nutrition Information</p>
                    </div>

                    {content && this.section == 1
                        ? this.renderMealControlButtons(meals[dishIndex], content, true)
                        : null}
                </header>

                <div className="section-body">
                    {nutrientTabs && nutrientTabs.length > 2 ? (
                        <MyTabs defaultTab={defaultTab} className="pill-tabs" htmlRef="nutrientTabs">
                            {nutrientTabs}
                        </MyTabs>
                    ) : (
                        nutrientTabs[1]
                    )}
                </div>
            </div>
        );
    };

    renderMealDetails = () => {
        const { dishIndex, meals, profile } = this.state;
        const { recipes, foods } = this.context;

        if (!(meals && meals[dishIndex])) {
            return (
                <div className="details-loading el-fonts">
                    <h4>Loading...</h4>
                    <i className="icon-spinner2" />
                </div>
            );
        }

        const meal = meals[dishIndex];

        const dish = getPrimaryMeal([meal], recipes, foods);
        const { primary, content } = dish;

        if (!(primary && content)) {
            return (
                <div className="details-loading el-fonts">
                    <h4>Loading...</h4>
                    <i className="icon-spinner2" />
                </div>
            );
        }

        if (content.type === 'recipe') {
            return this.renderRecipe(meal, content);
        }
        if (content.type === 'food') {
            return this.renderFood(meal, content);
        }
    };

    closeModal = () => {
        const { router } = this.context;
        const { closeModal } = this.props;

        if (closeModal) {
            closeModal();
            return;
        }

        router?.location?.state?.from ? router.push(router.location.state.from) : router.push('/meals');
    };

    scrollToDishIndex = (dishIndex, nutrientsIndex) => {
        const { meals } = this.state;
        const { location } = this.props;
        const { router } = this.context;
        const { pathname, query, hash } = location;

        if (!(meals && meals[dishIndex])) {
            return;
        }

        this.setState({ dishIndex }, () => {
            if (this.nutrientTabsRef.current?.setTab) {
                if (nutrientsIndex) {
                    this.nutrientTabsRef.setTab('Dish ' + nutrientsIndex);
                } else {
                    this.nutrientTabsRef.setTab('Combined');
                }
            }

            if (dishIndex != query.dishIndex) {
                const newQuery = Object.assign(query, {dishIndex});
                router.push({pathname, query: newQuery, hash});
            }
        });
    };

    removeMealsFromGroceries = (meals) => {
        const { removeMealsFromGroceries } = this.context;
        const { date, mealType } = this.state;

        removeMealsFromGroceries(meals);

        Analytics.removeMealFromGroceries(meals, mealType, date);
    };

    renderGroceryButton = () => {
        const { meals, primary, date, mealType } = this.state;
        const { recipes, foods, isPro } = this.context;

        if (!primary?.primary || isPro) {
            return;
        }

        if (!['fresh', 'food'].includes(primary.primary.meal_type)) {
            return;
        }

        // Are all these meals excluded from the grocery list?
        const excludedMeals = meals.filter((meal) => {
            if (meal.deleted) {
                return true;
            }

            const { content } = getPrimaryMeal([meal], recipes, foods);

            return content && content.exclude_from_groceries;
        });

        if (excludedMeals.length === meals.length) {
            return;
        }

        const mealOrders = MealStore.getOrdersForMeals(meals);

        return (
            <GroceryButton
                showAlert
                className="el-toolbar-cta-btn grocery-btn-style-2"
                defaultPopupPositionClass={'el-popup-top-right'}
                orders={mealOrders}
                meals={meals.filter((m) => !m.deleted)}
                primary={primary.primary}
                mealType={mealType}
                date={date}
            />
        );
    };

    getProtection = () => {
        const { primary } = this.state;
        const { recipe, food } = primary;

        let protection = 'public';

        if (recipe) {
            protection = recipe.protection;
        }

        if (food) {
            protection = food.protection;
        }

        return protection;
    };

    renderScheduleItButton = () => {
        const { profile } = this.state;
        const { capabilities = {} } = profile || {};

        const protection = this.getProtection();

        return (
            <button
                className="el-toolbar-green-pill-btn schedule-btn"
                onClick={() => this.setState({ isScheduling: true })}
            >
                schedule it
                {protection !== 'public' && !capabilities.meal_planner ? <i className="icon-lock" /> : null}
            </button>
        );
    };

    getOverlaps = (mealsToReschedule, date, mealType, userLeftovers = null) => {
        const { profile } = this.state;
        const { meals, recipes, foods, plans } = this.context;

        // Always use getRescheduleOverlaps - it handles both existing leftovers and conflicts
        const result = getRescheduleOverlaps(
            profile,
            meals,
            recipes,
            foods,
            plans,
            mealsToReschedule,
            date,
            mealType,
            [],
            userLeftovers
        );

        // If getRescheduleOverlaps says to show leftover modal (existing leftovers found)
        if (result.showLeftOverOffestModal) {
            return { shouldShowLeftoverModal: true, ...result };
        }

        return result;
    };

    addToCalendar = (date, mealType = 'Dinner') => {
        const { profile, primary, meals } = this.state;
        const { router, showUpgradeForm, meals: allMeals, recipes, foods, plans } = this.context;

        if (!primary) {
            return false;
        }

        const protection = this.getProtection();

        const { capabilities = {} } = profile || {};

        if (protection !== 'public' && !capabilities.meal_planner) {
            showUpgradeForm({ feature: 'meal_planner' });
            return false;
        }

        let dateFormatted = date.format('YYYY-MM-DD');

        // First check: do we need to show leftover modal?
        const result = this.getOverlaps(meals, date, mealType);

        if (result.shouldShowLeftoverModal) {
            // Need to show leftover modal first
            const { primary: primaryMeal, recipe } = getPrimaryMeal(meals, recipes, foods);
            const participants = getParticipantsForMeal(allMeals, primaryMeal, profile);

            // Only schedule fresh/food meals, not leftovers (they'll be recreated based on user selection)
            const freshMeals = meals.filter(m => m.meal_type === 'fresh' || m.meal_type === 'food');

            this.setState({
                isLeftoverDatesModalOpen: true,
                leftoverModalParams: {
                    meal: primaryMeal,
                    recipe: recipe,
                    participants: participants,
                    scaling: primaryMeal.scaling,
                },
                pendingSchedule: { date, mealType, meals: freshMeals },
            });
            return true;
        }

        const { overlaps, clears } = result;

        if (!overlaps.length) {
            meals.forEach((meal) => {
                meal.date = dateFormatted;
                meal.meal = mealType;
            });
            MealActions.upsertMeals(meals);
            router.push({ pathname: `/meals/${dateFormatted}/${mealType}` });
        } else {
            this.setState({
                isConfirmOverwriteOpen: true,
                mealsToReschedule: meals,
                confirmOverlaps: overlaps,
                confirmClears: clears,
                confirmDate: date,
                confirmMealType: mealType,
            });
        }

        return true;
    };

    onSelectLeftoverDates = (leftoverDates) => {
        const { pendingSchedule } = this.state;
        const { recipes, foods, meals: allMeals } = this.context;

        if (!pendingSchedule) {
            this.closeLeftoverDatesModal();
            return;
        }

        const { date, mealType, meals } = pendingSchedule;

        // Find old leftovers to delete (following MealActionsWrapper pattern)
        const oldLeftoversToDelete = [];
        meals.forEach((meal) => {
            if (meal.meal_type === 'fresh' || meal.meal_type === 'food') {
                const allParentLeftovers = allMeals.filter(
                    (m) => m.parent_uuid === meal.uuid && m.meal_type === 'leftover'
                );

                const oldLeftovers = allParentLeftovers.filter((m) => !m.deleted);

                oldLeftoversToDelete.push(...oldLeftovers);
            }
        });

        // Get main meal conflicts using getRescheduleOverlaps (pass empty array to skip leftover processing)
        // We'll manually create leftover overlaps below from user-selected leftovers
        const result = this.getOverlaps(meals, date, mealType, []);

        let { overlaps, clears } = result;

        // Manually create leftover overlaps for selected leftovers with conflicts
        // Following MealActionsWrapper.onShowConflictModal pattern
        // Filter out old leftover dates (before the new main meal date)
        const leftoverOverlaps = leftoverDates
            .filter((leftover) => leftover.conflictingMeals && leftover.conflictingMeals.length > 0)
            .filter((leftover) => !leftover.leftoverDate.isBefore(date, 'day'))
            .map((leftover) => {
                // Create virtual leftover meal objects for each meal being scheduled
                const sourceMeals = meals.map((meal) => {
                    const { recipe } = getPrimaryMeal([meal], recipes, foods);
                    return {
                        uuid: uuid.v4(),
                        meal_type: 'leftover',
                        meal: leftover.mealType,
                        date: leftover.leftoverDate.format('YYYY-MM-DD'),
                        recipe_uuid: meal.recipe_uuid,
                        food_uuid: meal.food_uuid,
                        parent_uuid: meal.uuid,
                        participants: leftover.participants.map((p) => p.uuid).join(','),
                        scaling: meal.scaling || 1,
                    };
                });

                return {
                    mealType: leftover.mealType,
                    date: leftover.leftoverDate,
                    destMeals: leftover.conflictingMeals,
                    sourceMeals: sourceMeals,
                };
            });

        // Combine main meal overlaps + leftover overlaps
        overlaps = [...overlaps, ...leftoverOverlaps];

        this.closeLeftoverDatesModal();

        if (!overlaps.length) {
            this.finalizeScheduling(meals, date, mealType, leftoverDates);
        } else {
            this.setState({
                isConfirmOverwriteOpen: true,
                mealsToReschedule: meals,
                confirmOverlaps: overlaps,
                confirmClears: clears,
                confirmDate: date,
                confirmMealType: mealType,
                confirmLeftoverDates: leftoverDates,
                additionalMealsToDelete: oldLeftoversToDelete,
            });
        }
    };

    finalizeScheduling = (meals, date, mealType, leftoverDates = null) => {
        const { router, meals: allMeals } = this.context;
        const dateFormatted = date.format('YYYY-MM-DD');

        // Find and delete all old leftovers (following MealActionsWrapper.completeRescheduleMeals)
        const mealsToDelete = [];
        meals.forEach((meal) => {
            meal.date = dateFormatted;
            meal.meal = mealType;

            if (meal.meal_type === 'fresh' || meal.meal_type === 'food') {
                const oldLeftovers = allMeals.filter(
                    (m) => m.parent_uuid === meal.uuid && m.meal_type === 'leftover' && !m.deleted
                );
                mealsToDelete.push(...oldLeftovers);
            }
        });

        this.onModifyMeals(meals, mealsToDelete, leftoverDates);
        router.push({ pathname: `/meals/${dateFormatted}/${mealType}` });
    };

    closeLeftoverDatesModal = () => {
        this.setState({
            isLeftoverDatesModalOpen: false,
            leftoverModalParams: null,
            pendingSchedule: null,
        });
    };

    renderLeftoverDatesModal = () => {
        const { isLeftoverDatesModalOpen, leftoverModalParams, pendingSchedule } = this.state;
        const { user, plans, meals, recipes, foods } = this.context;

        if (!isLeftoverDatesModalOpen || !leftoverModalParams) {
            return null;
        }

        const leftoverParams = {
            meal: {
                ...leftoverModalParams.meal,
                date: pendingSchedule.date.format('YYYY-MM-DD'),
                meal: pendingSchedule.mealType,
            },
            recipe: leftoverModalParams.recipe,
            participants: leftoverModalParams.participants,
            scaling: leftoverModalParams.scaling,
        };

        return (
            <LeftoverDatesModal
                user={user}
                meals={meals}
                recipes={recipes}
                foods={foods}
                plans={plans}
                leftoverParams={leftoverParams}
                ctaTitle="Continue"
                closeModal={this.closeLeftoverDatesModal}
                onSelectLeftoverOffsets={this.onSelectLeftoverDates}
            />
        );
    };

    closeConfirmOverwriteModal = () => {
        this.setState({
            isConfirmOverwriteOpen: false,
            confirmOverlaps: null,
            confirmClears: null,
            confirmDate: null,
            confirmMealType: null,
            confirmLeftoverDates: null,
            additionalMealsToDelete: null,
        });
    };

    renderConfirmOverwriteModal = () => {
        const {
            isConfirmOverwriteOpen,
            mealsToReschedule,
            confirmOverlaps,
            confirmClears,
            confirmDate,
            confirmMealType,
            confirmLeftoverDates,
            additionalMealsToDelete,
        } = this.state;

        if (!isConfirmOverwriteOpen || !mealsToReschedule) {
            return null;
        }

        const { user } = this.context;
        const mealTypes = user?.preferences?.meal_types || [];

        return (
            <ConfirmOverwriteModal
                meals={mealsToReschedule}
                onModifyMeals={this.onModifyMeals}
                overlaps={confirmOverlaps}
                isRepeatMeal={false}
                clears={confirmClears}
                date={confirmDate}
                mealType={confirmMealType}
                mealTypes={mealTypes}
                additionalMealsToDelete={additionalMealsToDelete}
                closeModal={this.closeConfirmOverwriteModal}
            />
        );
    };

    onModifyMeals = (mealsToUpsert, mealsToDelete = [], leftoverDates = null) => {
        let { confirmDate, confirmMealType, profile } = this.state;
        const { router, meals, groceries, recipes, details, foods } = this.context;

        mealsToDelete = mealsToDelete || [];
        let grocerySyncMeals = [],
            upsertLeftovers = [];

        // Filter out meals we're deleting so updateMealLeftovers doesn't reuse their UUIDs
        const uuidsToDelete = mealsToDelete.map(m => m.uuid);
        const filteredMeals = meals.filter(m => !uuidsToDelete.includes(m.uuid));

        mealsToUpsert.forEach((meal) => {
            delete meal.deleted;

            if (leftoverDates && meal.meal_type === 'fresh') {
                // Next update the leftovers.
                const { leftovers, toRemove } = updateMealLeftovers(
                    meal,
                    filteredMeals,  // Use filtered meals to prevent UUID reuse
                    recipes[meal.recipe_uuid],
                    profile,
                    leftoverDates
                );

                // Append the updated leftovers, and any leftovers that need to be removed, to our working lists.
                upsertLeftovers = upsertLeftovers.concat(leftovers);
                mealsToDelete = mealsToDelete.concat(toRemove);
            } else if (meal.meal_type === 'fresh' && !leftoverDates) {
                meals.forEach((item) => {
                    if (meal.uuid === item.parent_uuid) {
                        item.recipe_uuid = meal.recipe_uuid;
                        item.details_uuid = meal.details_uuid;

                        upsertLeftovers.push(item);
                    }
                });
            }

            // If this meal is already in the groceries and needs to be synchronized, sync it.
            if (isMealInGroceries(meal, groceries) && meal.scaling != meal.scaling_added_to_groceries) {
                grocerySyncMeals.push(meal);
            }
        });

        if (grocerySyncMeals.length > 0) {
            GroceryActions.syncMealsToGroceries(grocerySyncMeals, recipes, details, foods);
        }

        if (mealsToDelete && mealsToDelete.length > 0) {
            // Signal to the grocery list to remove ingredients too
            GroceryActions.removeMealsFromGroceries(mealsToDelete, recipes, details, foods);

            // Collect any leftovers for these meals as well.
            const uuidsToDelete = mealsToDelete.map((m) => m.uuid);
            const childrenToDelete = meals.filter((m) => uuidsToDelete.includes(m.parent_uuid));
            mealsToDelete = mealsToDelete.concat(childrenToDelete);

            // Mark all meals as deleted
            mealsToDelete.forEach((m) => (m.deleted = true));

            // Signal the Meal Store to remove the fresh meal & the leftovers
            MealActions.deleteMeals(mealsToDelete);
        }

        MealActions.upsertMeals(mealsToUpsert.concat(upsertLeftovers));

        const dateFormatted = confirmDate.format('YYYY-MM-DD');

        router.push({ pathname: `/meals/${dateFormatted}/${confirmMealType}` });
    };

    closeScheduleModal = () => {
        this.setState({ isScheduling: false });
    };

    renderSchedulingModal = () => {
        const { profile, isScheduling, primary } = this.state;

        if (!isScheduling) {
            return null;
        }

        const protection = this.getProtection();
        const { capabilities = {} } = profile || {};
        const plans = PlanStore.getPlans();

        return (
            <SchedulingModal
                content={primary.primary}
                isMealModal={true}
                isLocked={protection !== 'public' && !capabilities.meal_planner}
                selectDate={this.addToCalendar}
                closeModal={this.closeScheduleModal}
                profile={profile}
                plans={plans}
            />
        );
    };

    editSingleMeal = (meal, ev) => {
        const { dishIndex } = this.state;
        const { groceries, confirm } = this.context;
        let i = this.state.meals.indexOf(meal);

        if (i != dishIndex) {
            return this.scrollToDishIndex(i);
        }

        ev && ev.stopPropagation();

        // Is this meal in the grocery list already?
        if (isMealInGroceries(meal, groceries)) {
            confirm(
                'Please remove this meal from the grocery list before editing it, or the grocery list may not match the recipe.',
                (accept) => false,
                (reject) => false,
                { rejectText: null }
            );

            return;
        }

        this.setState({ editMealModal: meal });
    };

    deleteSingleMeal = (meal, ev) => {
        const { confirm, onRemoveMeals, recipes, foods } = this.context;
        const { dishIndex } = this.state;
        let i = this.state.meals.indexOf(meal);

        if (i != dishIndex) {
            return this.scrollToDishIndex(i);
        }

        ev && ev.stopPropagation();

        const pm = getPrimaryMeal([meal], recipes, foods);

        confirm(
            <div>
                <p>
                    Remove <em>{pm.titles.join(', ')}</em> from {meal.meal}, {moment(meal.date).format('dddd, MMM Do')}?
                </p>
            </div>,
            (accept) => {
                // Move to the next dish
                if (i > 1) {
                    this.scrollToDishIndex(i - 1);
                } else {
                    this.scrollToDishIndex(0);
                }

                onRemoveMeals([meal]);
            },
            (reject) => false
        );
    };

    isPast = (meal) => {
        const { currentMealType, user, plans } = this.context;

        let mode;

        if (moment(meal.date).isSame(moment(), 'day')) {
            mode = 'current';
            
            // Only calculate meal order if we need it (for current day)
            const dateSpecificMealTypes = getMealTypesForDate(meal.date, plans, user.preferences.meal_types);
            const mealTypeNames = dateSpecificMealTypes.map(mt => mt.name);
            
            const mealI = mealTypeNames.indexOf(meal.meal);
            const defaultMealIndex = mealTypeNames.indexOf(currentMealType);
            
            if (mealI < defaultMealIndex) {
                mode = 'past';
            }
        } else if (moment(meal.date).isBefore(moment(), 'day')) {
            mode = 'past';
        }

        return mode == 'past';
    };

    renderEditMealServingsButton = () => {
        const { editMealBatches } = this.context;
        const { profile, primary, meals, participants } = this.state;
        const { recipes, isPro } = this.context;

        if (!primary?.content) {
            return;
        }

        let totalTime = 0;

        meals.forEach((meal) => {
            totalTime =
                recipes[meal.recipe_uuid] &&
                recipes[meal.recipe_uuid].total_time &&
                recipes[meal.recipe_uuid].total_time > totalTime
                    ? recipes[meal.recipe_uuid].total_time
                    : totalTime;
        });

        let editMealServings = <div className="edit-meal-servings">&nbsp;</div>;

        if (isScalable(primary)) {
            let dishes = [];

            if (primary.dishes) {
                dishes.push(primary.dishes > 1 ? primary.dishes + ' dishes' : '1 dish');
            }

            if (primary.beverages) {
                dishes.push(primary.beverages > 1 ? primary.beverages + ' beverages' : '1 beverage');
            }

            const isLeftoverMeal = meals.some(meal => meal.meal_type === 'leftover');
            const participantCount = participants.length;

            const isMultiDish = meals.length > 1;
            let totalLeftoverServings = 0;
            let leftoverDishBreakdown = [];

            meals.forEach((meal, dishIndex) => {
                const dishRecipe = recipes[meal.recipe_uuid] || recipes[meal.food_uuid];
                const baseServings = getBaseServings(dishRecipe);
                const dishYield = calculateTotalYield(meal.scaling || 1, baseServings);
                const dishCurrentMealServings = calculateTotalServingsForParticipants(participants, meal, dishRecipe);
                const dishLeftoverServings = dishYield - dishCurrentMealServings;

                if (dishLeftoverServings > 0) {
                    if (isMultiDish) {
                        leftoverDishBreakdown.push({
                            dishNumber: dishIndex + 1,
                            dishName: dishRecipe?.title || dishRecipe?.name || `Dish ${dishIndex + 1}`,
                            servings: dishLeftoverServings
                        });
                    }
                    totalLeftoverServings += dishLeftoverServings;
                }
            });

            // Check if editable (only if editMealBatches function exists)
            const isEditable = !!editMealBatches;
            const servesClassName = isEditable ? 'serves' : 'serves disabled';

            editMealServings = (
                <div className="edit-meal-servings" onClick={() => editMealBatches && editMealBatches(primary.primary)}>
                    <section className={servesClassName}>
                        <div>
                            <div>{isLeftoverMeal ? 'Leftover Meal' : 'Serves'}</div>
                            <div className="servings">{participantCount} {participantCount === 1 ? 'person' : 'people'}</div>
                        </div>

                        {!isLeftoverMeal && totalLeftoverServings > 0 ? <div className="plus">+</div> : null}

                        {!isLeftoverMeal && totalLeftoverServings > 0 ? (
                            <div>
                                <div>Leftovers</div>
                                {isMultiDish && leftoverDishBreakdown.length > 0 ? (
                                    <div className="servings leftover-breakdown">
                                        {leftoverDishBreakdown.map((dish, index) => (
                                            <div key={index}>Dish {dish.dishNumber}: {dish.servings} {dish.servings === 1 ? 'serving' : 'servings'}</div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="servings">{totalLeftoverServings} {totalLeftoverServings === 1 ? 'serving' : 'servings'}</div>
                                )}
                            </div>
                        ) : null}

                        {isEditable && <div className="edit">EDIT</div>}
                    </section>

                    <section className="timings">
                        <p className="dish-count">{dishes.join(', ')}</p>
                        {totalTime ? (
                            <p>
                                {toHuman(totalTime, true)}
                                <br />
                                prep/cook
                            </p>
                        ) : null}
                    </section>
                </div>
            );
        }

        return editMealServings;
    };

    renderControlBar = () => {
        const { hidePrintBtn, params } = this.props;
        const { isMobile, startAddMeal, startReplaceMeal } = this.context;
        const { profile, primary, dishIndex, meals, isMismatched, isOverLimits, participants } = this.state;
        const { recipes, foods, isPro } = this.context;

        if (!primary) {
            return;
        }

        const { inhibit_swap = false, rd_override = false } = profile;

        const isPast = this.isPast(primary.primary);
        const hasScheduledMeals = meals.length > 0;

        const ctaBtn = isPast && !isPro && !hasScheduledMeals ? this.renderScheduleItButton() : this.renderGroceryButton();

        // If we've met our nutrition needs OR we've gone over, default to the search foods & recipes engine
        // instead of smart choices engine.
        let addOpts = !isMismatched || isOverLimits ? { defaultMode: 'browser' } : {};
        if (meals.length > 0) addOpts.participants = participants;

        const swapMenu =
            meals.length == 1 ? (
                <SwapMenu className="el-toolbar-btn" icon="icon-swap" primary={primary.primary} options={{fullBrowserParams: {defaultTypes: ['recipe']}}} />
            ) : (
                <Popup
                    positionClassName="el-popup-top-right"
                    className="el-toolbar-popup swap-popup"
                    button={
                        <>
                            <i className="icon-swap" /> SWAP
                        </>
                    }
                >
                    <h6>Swap</h6>
                    <SwapMenu className="swap-popup-btn" primary={primary.primary} button={<>Entire Meal</>} options={{fullBrowserParams: {defaultTypes: ['recipe']}}}  />

                    {meals.map((meal, i) => (
                        <SwapMenu
                            key={i}
                            className="swap-popup-btn"
                            primary={meal}
                            options={{
                                replace_single: true,
                                fullBrowserParams: { defaultTypes: ['recipe'] }
                            }}
                            button={
                                <>
                                    DISH {i + 1}: <em>{primary.titles[i]}</em>
                                </>
                            }
                        />
                    ))}
                </Popup>
            );

        return (
            <div className={classNames('control-bar-container el-toolbar1', !isMobile ? 'el-toolbar1-dark' : null)}>
                {!hidePrintBtn ? (
                    <RecipeToPdfButton
                        className="el-toolbar-popup"
                        positionClassName="el-popup-top-left"
                        button={
                            <>
                                <i className="icon-print" /> <em>print</em>
                            </>
                        }
                        recipe={primary.recipe ? primary.primary : null}
                        meal={primary.primary}
                    />
                ) : null}

                <MultiSharePopup className="el-toolbar-popup" positionClassName="el-popup-top-center" meals={meals} />

                {startAddMeal ? (
                    <button
                        className="el-toolbar-btn add-btn"
                        onClick={() => startAddMeal(moment(params.date), params.mealType, addOpts)}
                    >
                        <i className="feather feather-plus" /> <em>add</em>
                    </button>
                ) : null}

                {(!inhibit_swap || rd_override) && startReplaceMeal ? swapMenu : null}

                {ctaBtn}
            </div>
        );
    };

    renderScrollHero = () => {
        const { breakpoint47em, isCordova, isMobile } = this.context;
        const { meals, dishIndex } = this.state;

        const { recipes, foods, brands, startReplaceMeal, onRemoveMeals } = this.context;
        const { profile } = this.state;

        let isSafariMobile = false;

        if (isMobile && !isCordova && platform.name === 'Safari') {
            isSafariMobile = true;
        }

        return (
            <SpringHero
                meals={meals.filter((m) => !['note'].includes(m.meal_type))}
                dishIndex={dishIndex}
                profile={profile}
                recipes={recipes}
                foods={foods}
                brands={brands}
                breakpoint47em={breakpoint47em}
                startReplaceMeal={startReplaceMeal}
                editSingleMeal={this.editSingleMeal}
                deleteSingleMeal={this.deleteSingleMeal}
                scrollToDishIndex={this.scrollToDishIndex}
                onRemoveMeals={onRemoveMeals}
                isSafariMobile={isSafariMobile}
                isMobile={isMobile}
            />
        );
    };

    closeEditMealModal = () => {
        this.setState({ editMealModal: null });
    };

    onSaveRecipe = (meal, recipe, details) => {
        const { profile } = this.state;
        const { onModifyMeals } = this.context;

        meal.recipe_uuid = recipe.uuid;
        meal.details_uuid = details.uuid;
        // Reset logged grams to default in case recipe grams_per_serving changed
        meal.logged_grams = Math.round(recipe.grams_per_serving * 1000) / 1000 * profile.portion;
        // Reset logged milliliters to default in case recipe milliliters_per_serving changed
        meal.logged_milliliters = Math.round(recipe.milliliters_per_serving * 1000) / 1000 * profile.portion;

        const otherMeals = MealStore.getMeals().filter(m => m.recipe_uuid === recipe.uuid && m.uuid !== meal.uuid);

        otherMeals.forEach(m => {
            const loggedServings = getLoggedServingsOfRecipe(m, recipe, false);
            m.logged_grams = Math.round(recipe.grams_per_serving * 1000) / 1000 * (loggedServings || profile.portion);
            m.logged_milliliters = Math.round(recipe.milliliters_per_serving * 1000) / 1000 * (loggedServings || profile.portion);
        });

        // If the recipe & details UUID changed, this should trigger a full sync.
        onModifyMeals([meal, ...otherMeals]);

        this.closeEditMealModal();
    };

    onSaveFood = (meal, food) => {
        const { profile } = this.state;
        const { onModifyMeals } = this.context;

        meal.food_uuid = food.uuid;
        // Reset logged grams to default in case food serving size changed
        if (food.default_unit && food.default_unit.grams) {
            meal.logged_grams = Math.round(food.default_unit.grams * 1000) / 1000 * profile.portion;
        }
        if (food.default_unit && food.default_unit.milliliters) {
            meal.logged_milliliters = Math.round(food.default_unit.milliliters * 1000) / 1000 * profile.portion;
        }

        const otherMeals = MealStore.getMeals().filter(m => m.food_uuid === food.uuid && m.uuid !== meal.uuid);

        otherMeals.forEach(m => {
            if (food.default_unit && food.default_unit.grams) {
                m.logged_grams = Math.round(food.default_unit.grams * 1000) / 1000 * profile.portion;
            }
            if (food.default_unit && food.default_unit.milliliters) {
                m.logged_milliliters = Math.round(food.default_unit.milliliters * 1000) / 1000 * profile.portion;
            }
        });

        // If the food UUID changed, this should trigger a full sync.
        onModifyMeals([meal, ...otherMeals]);

        this.closeEditMealModal();
    };

    renderEditMealModal = () => {
        const { profile, editMealModal } = this.state;

        let editorComponent = null;

        if (!editMealModal) {
            return;
        }

        const { recipe_uuid, food_uuid } = editMealModal;

        let modalTitle = '';

        if (recipe_uuid) {
            modalTitle = 'Edit Recipe';
            editorComponent = (
                <RecipeEditor
                    uuid={recipe_uuid}
                    profile={profile}
                    closeModal={this.closeEditMealModal}
                    onSaveRecipe={(recipe, details) => this.onSaveRecipe(editMealModal, recipe, details)}
                />
            );
        } else if (food_uuid) {
            return (
                <FoodEditorModal
                    uuid={food_uuid}
                    modalTitle="Edit Custom Food"
                    contentLabel="Edit Recipe Details"
                    onSaveFood={(food) => {
                        Analytics.savedCustomFood({
                            Context: 'Meal Details',
                            'Food UUID': food_uuid,
                        });
                        this.onSaveFood(editMealModal, food);
                    }}
                    closeModal={this.closeEditMealModal}
                />
            );
        }

        if (!editorComponent) {
            return null;
        }

        return (
            <Modal
                isOpen={true}
                onRequestClose={this.closeEditMealModal}
                closeModal={this.closeEditMealModal}
                className="el-modal el-modal1"
                overlayClassName="el-modal-overlay"
                contentLabel="Edit Recipe Details"
            >
                <div className="el-modal-container el-modal1-container el-modal1-recipe-editor-container">
                    <header data-has-controls={false}>
                        <button className="el-modal-back-btn" onClick={this.closeEditMealModal}>
                            <span>Back</span>
                        </button>

                        <h2>{modalTitle}</h2>
                    </header>

                    <div className="el-modal-body-container el-modal1-body-container el-fonts">
                        {editorComponent}
                    </div>
                </div>
            </Modal>
        );
    };

    renderModalBody = () => {
        return (
            <>
                {this.renderScrollHero()}
                {this.renderMealDetails()}
                {this.renderNutritionTabs()}
            </>
        );
    };

    section = 0;

    render() {
        const { isMobile } = this.context;
        const { profile, date, mealType } = this.state;

        if (!profile) {
            return (
                <div className="my-account-login">
                    <Helmet title="Please sign-in or register | EatLove" />
                    <LoginForm defaultSignUp={false} />
                    <Footer />
                </div>
            );
        }

        let dateFormatted = date.format('dddd, MMM D');

        if (date.isSame(moment(), 'day')) {
            dateFormatted = 'Today';
        } else if (date.isSame(moment().add(1, 'day'), 'day')) {
            dateFormatted = 'Tomorrow';
        } else if (date.isSame(moment().subtract(1, 'day'), 'day')) {
            dateFormatted = 'Yesterday';
        }

        this.section = 0;

        return (
            <>
                <Helmet title={`${mealType} ${dateFormatted} | EatLove`} />
                <Modal
                    isOpen={true}
                    onRequestClose={this.closeModal}
                    closeModal={this.closeModal}
                    className="el-modal el-modal1"
                    overlayClassName="el-modal-overlay"
                    contentLabel="Meal Details"
                >
                    <div className="el-modal-container el-modal1-container content-details-modal-container meal-details">
                        <header data-has-controls={isMobile}>
                            <button className="el-modal-back-btn" onClick={this.closeModal}>
                                <span>Back</span>
                            </button>

                            <h2>
                                {isMobile ? (
                                    <>
                                        {dateFormatted}, <em>{mealType}</em>
                                    </>
                                ) : (
                                    'Meal Information'
                                )}
                            </h2>

                            {isMobile ? (
                                <>
                                    {this.renderEditMealServingsButton()}

                                    <div className="el-modal-controls el-modal1-controls">
                                        <header>{this.renderControlBar()}</header>
                                    </div>
                                </>
                            ) : null}
                        </header>

                        <div className="el-modal-body-container el-modal1-body-container el-fonts">
                            {!isMobile ? (
                                <div className="details-header">
                                    <h6>
                                        {dateFormatted}, <em>{mealType}</em>
                                    </h6>
                                    {this.renderEditMealServingsButton()}
                                    <header>{this.renderControlBar()}</header>
                                </div>
                            ) : null}

                            {this.renderModalBody()}
                        </div>
                    </div>

                    {this.renderEditMealModal()}
                    {this.renderSchedulingModal()}
                    {this.renderLeftoverDatesModal()}
                    {this.renderConfirmOverwriteModal()}
                </Modal>
            </>
        );
    }
}
